// src/services/axiosClient.js or axiosClient.ts
import axios from "axios";


const sanctum_axios_client = axios.create({
  baseURL: `${process.env.REACT_APP_EDUCATION_VIDEO_BASE_URL}`,
  withCredentials: true,
  withXSRFToken: true,
   headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
});





export default sanctum_axios_client;
